import { Outlet } from 'react-router-dom';

const WebDashboard = () => (
  <div>
    <Outlet />
  </div>
);

export default WebDashboard;
